import { AnimatePresence, motion, useInView } from 'framer-motion';
import * as React from 'react';

export function GradualSpacing({ text = 'Gradual Spacing', renderChar }: { text: string, renderChar?: (char: string, i: number) => React.ReactNode }) {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });
  return (
    <div className="flex flex-wrap space-x-1 justify-center" ref={ref}>
      <AnimatePresence>
        {text.split('').map((char, i) => (
          <motion.p
            key={i}
            initial={{ opacity: 0, x: -18 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            exit="hidden"
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="text-xl text-center sm:text-4xl font-bold tracking-tighter md:text-6xl md:leading-[4rem]"
          >
            {renderChar ? renderChar(char, i) : (char === ' ' ? <span>&nbsp;</span> : char)}
          </motion.p>
        ))}
      </AnimatePresence>
    </div>
  );
}
